import { Reason } from '@/contexts/ServiceAvailability/ServiceAvailabilityContext';

export enum FeatureName {
  SEARCH = 'weapons.search',

  ERZ_SERVICES = 'erz_services.availability',
  ERZ_REGISTRY = 'erz_services.registry',
  ERZ_TEMPORARY_RESIDENCE_RELOCATION = 'erz_services.temporary_residence_relocation',
  ERZ_CANCELLATION_TEMPORARY_RESIDENCE_RELOCATION = 'erz_services.cancellation_temporary_residence_relocation',

  IAC_SERVICES = 'iac_services.availability',

  BIA_SERVICES = 'bia_services.availability',
  BIA_INSURANCE = 'bia_services.insurance',
}

export enum ERZServiceLockedReason {
  NO_LINK = 'NO_LINK',

  TIMEOUT_PERMIT = 'TIMEOUT_PERMIT',
  EXPIRED_PERMIT_STORAGE_AND_STORE = 'EXPIRED_PERMIT_STORAGE_AND_STORE',
  EXPIRED_PERMIT_TEMP_RELOCATION = 'EXPIRED_PERMIT_TEMP_RELOCATION',
  NO_CITIZENSHIP_OR_RESIDENCE_DOCUMENT = 'NO_CITIZENSHIP_OR_RESIDENCE_DOCUMENT',
}

export enum BIAServiceLockedReason {
  TIME_UP = 'TIME_UP',
}

export interface ResponseFeatures {
  [FeatureName.SEARCH]: [boolean, null];

  [FeatureName.ERZ_SERVICES]: [
    boolean,
    Nullable<Exclude<ERZServiceLockedReason, ERZServiceLockedReason.NO_LINK> | Reason.REGISTERED_ADDRESS_ABROAD>,
  ];
  [FeatureName.ERZ_TEMPORARY_RESIDENCE_RELOCATION]: [boolean, Nullable<Reason.DUPLICATED_APPLICATION>];
  [FeatureName.ERZ_CANCELLATION_TEMPORARY_RESIDENCE_RELOCATION]: [boolean, Nullable<Reason.DUPLICATED_APPLICATION>];
  [FeatureName.ERZ_REGISTRY]: [boolean, Nullable<ERZServiceLockedReason.NO_LINK>];

  [FeatureName.IAC_SERVICES]: [boolean, Nullable<Reason.MIN_USER_AGE | Reason.UNAVAILABLE_MIN_USER_AGE>];

  [FeatureName.BIA_SERVICES]: [
    boolean,
    Nullable<Reason.MIN_USER_AGE | Reason.SERVICE_NOT_AVAILABLE | Reason.RNOKPP_MISSING>,
  ];
  [FeatureName.BIA_INSURANCE]: [boolean, Nullable<BIAServiceLockedReason.TIME_UP>];
}
